const pt = {
  tools_actions: {
    hotel_info: "A procurar informações sobre o hotel...",
    accommodation_info: "A procurar informações sobre o hotel...",
    accomodation_info: "A procurar informações sobre o hotel...",
    get_destination_info: "A procurar o que fazer na zona...",
    get_guest_information: "A verificar a sua reserva...",
    book_hotel_service_or_get_availability: "A verificar a disponibilidade do serviço...",
    list_accomodations: "A carregar as unidades...",
    set_accomodation: "A carregar a unidade...",
    list_accommodations: "A carregar as unidades...",
    set_accommodation: "A carregar a unidade...",
    destination_info: "A procurar o que fazer na zona...",
    show_map: "A preparar o mapa...",
    consult_rules: "A consultar as regras da unidade...",
    notify_reception: "A avisar a receção...",
    save_self_declared_stay: "A registar a sua estadia...",
    generate_quote_for_single_room_longstay_rooms: "A preparar um orçamento...",
    generate_quote_for_multiple_rooms_longstay: "A preparar um orçamento...",
    hotel_info_iodah: "Perfeito, recolho a informação e volto já para junto de si...",
    generate_quote_for_rooms: "A preparar um orçamento...",
    check_availability: "A verificar disponibilidade...",
    print_calendar: "A verificar o calendário...",
    nearby_restaurants: "A procurar restaurantes na zona...",
    nearby_attractions: "A procurar atrações na zona...",
    human_handoff: "A ligar a um colaborador...",
    tool_search_offers_by_request: "A procurar as melhores ofertas para si...",
    tool_search_hotels_by_request: "A procurar os melhores hotéis para si...",
  },
  tool_status_sequences: {
    generate_quote_for_rooms: [
      "A verificar a disponibilidade para as suas datas…",
      "A comparar quartos e tarifas…",
      "A preparar o orçamento…",
    ],
    generate_quote_for_single_room_longstay_rooms: [
      "A verificar a disponibilidade para as suas datas…",
      "A comparar quartos e tarifas…",
      "A preparar o orçamento…",
    ],
    generate_quote_for_multiple_rooms_longstay: [
      "A verificar a disponibilidade para as suas datas…",
      "A comparar quartos e tarifas…",
      "A preparar o orçamento…",
    ],
    check_availability: [
      "A verificar o calendário…",
      "A confirmar a disponibilidade…",
      "Só mais um instante…",
    ],
    hotel_info: [
      "A consultar as informações do hotel…",
      "A recolher os detalhes…",
      "A preparar a resposta…",
    ],
    accommodation_info: [
      "A consultar as informações do hotel…",
      "A recolher os detalhes…",
      "A preparar a resposta…",
    ],
    accomodation_info: [
      "A consultar as informações do hotel…",
      "A recolher os detalhes…",
      "A preparar a resposta…",
    ],
    get_destination_info: [
      "A explorar os arredores…",
      "A reunir as melhores sugestões…",
      "Quase pronto…",
    ],
    nearby_restaurants: [
      "A procurar restaurantes na zona…",
      "A selecionar os mais adequados…",
      "Quase pronto…",
    ],
    nearby_attractions: [
      "A procurar o que fazer na zona…",
      "A selecionar o melhor…",
      "Quase pronto…",
    ],
    get_guest_information: [
      "A recuperar a sua reserva…",
      "A verificar os detalhes da estadia…",
      "Só mais um instante…",
    ],
    book_hotel_service_or_get_availability: [
      "A verificar a disponibilidade do serviço…",
      "A confirmar os horários…",
      "Só mais um instante…",
    ],
    print_calendar: ["A abrir o calendário…", "A verificar as datas…"],
    list_accomodations: ["A carregar as unidades…", "A preparar a lista…"],
    set_accomodation: ["A abrir a unidade…", "A recuperar as informações…"],
    list_accommodations: ["A carregar as unidades…", "A preparar a lista…"],
    set_accommodation: ["A abrir a unidade…", "A recuperar as informações…"],
    destination_info: [
      "A explorar os arredores…",
      "A reunir as melhores sugestões…",
      "Quase pronto…",
    ],
    show_map: ["A localizar os lugares no mapa…", "A preparar o itinerário…"],
    consult_rules: ["A consultar as regras da unidade…", "A verificar as condições…"],
    notify_reception: ["A avisar a receção…", "A encaminhar o pedido…"],
    save_self_declared_stay: ["A registar a sua estadia…", "A associar a reserva…"],
    human_handoff: ["A avisar a receção…", "A passar a conversa…"],
    tool_search_offers_by_request: [
      "A procurar as melhores ofertas para si…",
      "A comparar as soluções…",
      "Quase pronto…",
    ],
    tool_search_hotels_by_request: [
      "A procurar os hotéis mais adequados…",
      "A comparar as soluções…",
      "Quase pronto…",
    ],
  },
  status_thinking: ["Um momento…", "Estou a pensar nisso…", "Só mais um instante…"],
  status_generic: ["Quase lá…", "Só mais um instante…"],
  tooltip_sentences: [
    "Quer um orçamento rápido? 😊",
    "Quer informações sobre o hotel? 😊",
  ],
  tooltip_sentences_iodah: [
    "Bem-vindo ao The First Hotels.",
    "Como posso ajudá-lo hoje?",
  ],
  welcome_message_default:
    "Olá! 👋 Sou o assistente virtual do hotel. Posso verificar disponibilidade e preços e responder a qualquer dúvida sobre a sua estadia. Como posso ajudá-lo?",
  teaser_pill_fixed: "Orçamento em 30 segundos ⚡",
  teaser_pills_rotating: [
    "Tem disponibilidade para as minhas datas? 📅",
    "Que quartos têm? 🛏️",
    "Como é o pequeno-almoço? 🥐",
  ],
  quote_pills: {
    alone: "Viajo sozinho",
    alone_message: "Viajo sozinho, uma pessoa",
    party: "Somos {n}",
    party_message: "Somos {n} pessoas",
  },
  replies_in_realtime: "Respostas em tempo real",
  ai_disclosure: "Sou o assistente de IA da unidade. Pode pedir para falar com a equipa quando quiser.",
  assistant_default_name: "Nome do Assistente",
  powered_by: "Desenvolvido por",
  type_a_message: "Escreva uma mensagem...",
  speak_with_operator: "Fale com um colaborador",
  // "Call us" card in the welcome message (VoiceCallCard).
  voice_call: {
    title: "Ligue-nos",
    subtitle: "Atende de imediato o nosso assistente de voz",
    badge: "Novo",
    call: "Ligar",
    copy: "Copiar o número",
    copied: "Número copiado",
  },
  voice_panel: {
    status_idle: "Pronto",
    status_connecting: "A preparar a voz...",
    status_listening: "A ouvir",
    status_error: "Erro de ligação",
    status_warming: "A preparar a voz...",
    transcript_empty: "Diga alguma coisa…",
    end_call: "Terminar a chamada",
    start_call: "Iniciar a chamada de voz",
    start_mode: "Ativar o modo de voz",
    stop_mode: "Parar o modo de voz",
  },
  continue_on_whatsapp: "Continuar no WhatsApp",
  whatsapp_handoff_prefill:
    "Olá! Estava a conversar com o assistente do site e gostava de continuar por aqui.",
  request_quote: "Pedir um orçamento",
  map_directions: "Abrir no Maps",
  handoff_form: {
    title: "Contacte-nos",
    desc: "Deixe-nos os seus dados e a nossa equipa entrará em contacto consigo o mais brevemente possível.",
    firstname: "Nome",
    lastname: "Apelido",
    email: "Email",
    phone: "Telefone",
    phone_hint: "Vamos usá-lo para o contactar, também pelo WhatsApp.",
    phone_search: "Procurar país",
    submit: "Enviar pedido",
    success:
      "Obrigado! Recebemos os seus dados e entraremos em contacto consigo o mais brevemente possível. 😊",
    handoff_email_success:
      "Respondemos-lhe por email para {email}. Pode fechar esta página.",
    submit_error: "Algo correu mal. Tente novamente daqui a pouco.",
    firstname_error: "Indique o seu nome.",
    lastname_error: "Indique o seu apelido.",
    email_error: "Indique um endereço de email válido.",
    phone_error: "Indique um número de telefone válido.",
    close_aria_label: "Fechar",
  },
  error_generic: "Algo correu mal. Tente novamente mais tarde.",
  delete_chat_aria_label: "Eliminar conversa",
  close_aria_label: "Fechar conversa",
  send_aria_label: "Enviar mensagem",
  chat_widget_aria_label: "Widget de chat",
  previous_aria_label: "Anterior",
  next_aria_label: "Seguinte",
  attachment_alt: "Anexo",
  assistant_icon_alt: "Ícone do assistente",
  bot_avatar_alt: "Avatar do assistente",
  video_label: "Vídeo {n}",
  open_content: "Abrir conteúdos",
  book_now: "Reserve agora",
  // Inline link chips in a message (CustomLinkRenderer): shown next to the
  // address/number the assistant wrote, and used as the accessible label.
  send_email: "Enviar um email",
  call_now: "Ligar",
  whatsapp_chat: "Escreva-nos no WhatsApp",
  open_link: "Abrir a ligação",
  discover_hotel: "Descubra o hotel",
  discover_offer: "Descubra a oferta",
  quick_quote: "Peça um orçamento",
  view_hotel_photos: "Veja as fotos do hotel",
  view_photos: "Veja as fotos",
  hotel_gallery: "Hotel",
  restaurant_gallery: "Restaurante",
  animation_gallery: "Animação",
  rooms_gallery: "Quartos",
  look_hotel_galleries: "Veja as outras galerias do hotel:",
  back_to_chat: "Voltar à conversa",
  carousel_open: "Abrir",
  carousel_close: "Fechar",
  available: "Disponível",
  expand_view: "Vista imersiva",
  read_more: "Ler mais",
  explore: "Explorar",
  photo: "Foto",
  from_price: "a partir de",
  rates: "Tarifas",
  quote_group: {
    title: "O seu orçamento",
    total: "Total",
    room: "Quarto {n}",
    other_options: "Outras opções",
    rooms: "{n} quartos",
    adult: "adulto",
    adults: "adultos",
    child: "criança",
    children: "crianças",
  },
  anchor_rooms: "As nossas propostas",
  anchor_discover: "Para descobrir",
  anchor_places: "Localização e arredores",
  anchor_videos: "Vídeos",
  videos: "vídeos",
  watch_video: "Veja o vídeo",
  feedback_useful: "Resposta útil",
  feedback_not_useful: "Pouco útil",
  proposal: "proposta",
  proposals: "propostas",
  contents: "conteúdos",
  places: "lugares",
  explore_title: "A sua estadia",
  explore_rooms: "Quartos e tarifas",
  explore_discover: "Para descobrir",
  explore_videos: "Vídeos",
  explore_places: "Lugares",
  directions: "Como chegar",
  minimize_view: "Reduzir",

  // 1x6 P2-d-M · interactive concierge map (poi_map / itinerary templates).
  anchor_itinerary: "O seu itinerário",
  itinerary: "Itinerário",
  stops: "paragens",
  stop: "paragem",
  walk_min: "min a pé",
  itinerary_start: "Ponto de partida",
  your_hotel: "O seu hotel",
  explore_itineraries: "Itinerários",
  map_loading: "A carregar o mapa…",
  cat_restaurant: "Comer e beber",
  cat_attraction: "Atrações",
  cat_beach: "Praias",
  cat_essential: "Serviços úteis",
  cat_event: "Eventos",
  cat_place: "Lugar",
  reviews: "avaliações",

  // Fluxo de reserva no widget. Na v0.5 corre contra o driver de teste:
  // nada é reservado em lado nenhum, e é exatamente isso que mock_notice
  // serve para dizer em voz alta.
  booking: {
    choose_rate: "Escolha a tarifa",
    your_details: "Os seus dados",
    review: "Resumo",
    notes: "Notas ou pedidos",
    notes_placeholder: "Alergias, hora de chegada, berço…",
    privacy: "Li e aceito a política de privacidade.",
    marketing: "Quero receber ofertas e novidades do hotel.",
    privacy_required: "É necessário aceitar a privacidade para continuar.",
    continue: "Continuar",
    back: "Voltar",
    confirm: "Confirmar reserva",
    submitting: "Um momento…",
    cancel: "Cancelar",
    close: "Fechar",
    retry: "Tentar novamente",
    total: "Total",
    cheapest: "Mais económica",
    per_night: "por noite",
    no_payment_now: "Sem pagamento agora",
    nights: "noites",
    guests: "hóspedes",
    reference: "Referência",
    success_title: "Reserva confirmada",
    success_body: "Vai receber a confirmação por email em breve.",
    error_title: "Não foi possível concluir",
    error_body:
      "Não conseguimos concluir a reserva. Tente novamente daqui a pouco.",
    mock_notice: "Modo de teste: não foi criada nenhuma reserva real.",
  },
};

export default pt;
